const DESIGN_SYSTEM_PATH = process.env.NEXT_PUBLIC_DESIGN_SYSTEM_PATH || process.env.STORYBOOK_DESIGN_SYSTEM_PATH || '';

export function getDesignSystemIcon(icon: string) {
  return `${DESIGN_SYSTEM_PATH}/images/icons/${icon}`;
}

export function getDesignSystemImage(image: string) {
  return `${DESIGN_SYSTEM_PATH}/images/${image}`;
}

export function getDesignSystemFontfile(file: string) {
  return `${DESIGN_SYSTEM_PATH}/fonts/stihl-contraface/${file}`;
}

export function getDesignSystemAnimation(image: string) {
  return `${DESIGN_SYSTEM_PATH}/images/animations/${image}`;
}
